module.exports = "/_next/static/images/f7e18e47e96f752ce5e817a7315f39ed-credit-card-perks-lg-1x.png.webp";